
import { MotimaticUser } from "../motimaticUser.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class MotimaticUserSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new MotimaticUser();
        this._copyAttributesUserNameDropDown(gp, data);
        return gp;

    }

}
